import { connect } from 'react-redux'
import { map, join, isEmpty } from 'lodash'

import SuitesCustomer from '../../components/Customer'
import { loadCustomers, onSelectCustomer } from '../../store/Customer/actions'
import { getCustomersAndAssignedSuites, getSearchCustomerValue } from '../../store/Customer/selector'
import { loadAllCustomerOrderingPreferences } from '../../store/CustomerOrderingPreference/actions'
import { loadRevenueCenters } from '../../store/RevenueCenter/actions'
import { getCurrentVenueUuid } from '../../store/Venues/selector'

const mapStateToProps = state => {
  const currentVenueUuid = getCurrentVenueUuid(state)
  const customersWithSuites = getCustomersAndAssignedSuites(state)
  const searchCustomerValue = getSearchCustomerValue(state)
  const formattedCustomers = customersWithSuites.reduce((aggregate, customer) => {
    if (!isEmpty(customer.suites)) {
      aggregate.push({
        ...customer,
        suites: isEmpty(customer.suites) ? 'none' : join(map(customer.suites, 'name'), ', ')
      })
    }
    return aggregate
  }, [])

  return { currentVenueUuid, customers: formattedCustomers, searchCustomerValue }
}

const mapDispatchToProps = {
  loadCustomers,
  loadAllCustomerOrderingPreferences,
  loadRevenueCenters,
  onSelectCustomer,
}

export default connect(mapStateToProps, mapDispatchToProps)(SuitesCustomer)
